import { render, staticRenderFns } from "./QcTool.vue?vue&type=template&id=1c520529&scoped=true"
import script from "./QcTool.vue?vue&type=script&lang=js"
export * from "./QcTool.vue?vue&type=script&lang=js"
import style0 from "./QcTool.vue?vue&type=style&index=0&id=1c520529&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c520529",
  null
  
)

export default component.exports